import { createRouteConfig } from 'modules/router/utils/createRouteConfig';

const PATH_BILLING = '/account/';
const PATH_BILLING_USAGE = `${PATH_BILLING}usage/`;
const PATH_CARDPAYMENT_SUCCESS = `${PATH_BILLING}success/`;
const PATH_CARDPAYMENT_FAILURE = `${PATH_BILLING}failure/`;

export const billingRoutesConfig = createRouteConfig(
  {
    billing: {
      path: PATH_BILLING,
      generatePath: () => PATH_BILLING,
    },
    usage: {
      path: PATH_BILLING_USAGE,
      generatePath: () => PATH_BILLING_USAGE,
    },
    cardPaymentSuccess: {
      path: PATH_CARDPAYMENT_SUCCESS,
      generate: () => PATH_CARDPAYMENT_SUCCESS,
    },
    cardPaymentFailure: {
      path: PATH_CARDPAYMENT_FAILURE,
      generate: () => PATH_CARDPAYMENT_FAILURE,
    },
  },
  PATH_BILLING,
);
